export default __webpack_public_path__ + "static/media/Tips & Contracts - Megosu.f55e9d2a.pdf";